import { render, staticRenderFns } from "./DeveloperAPI.vue?vue&type=template&id=015788a4&"
import script from "./DeveloperAPI.vue?vue&type=script&lang=js&"
export * from "./DeveloperAPI.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperAPI.vue?vue&type=style&index=0&id=015788a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports